module.exports = __webpack_public_path__ + "static/media/code.a9f5aba3.png";